<template>
  <div>
    <canvas-page :canvasData='canvasData'></canvas-page>
<!--    <serve></serve>-->
  </div>
</template>

<script>
import CanvasPage from '../../components/canvasShow/canvasShowPage'
import testData from './testData'
// import Serve from "../../components/serve/serve";

export default {
  name: 'index',
  components: { CanvasPage},
  data() {
    return {
      canvasData: []
    }
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'overflow-y:auto;min-width:1420px;')
    // document.querySelector('body').setAttribute('style', 'overflow-y:auto;min-width:1420px;filter:progid:DXImageTransform.Microsoft.BasicImage(graysale=1);-webkit-filter: grayscale(100%)')

  },
  beforeDestroy() {
    document.body.removeAttribute('style')
  },
  mounted() {
    this.canvasData = testData.pcData
  }
}
</script>

<style lang="scss" scoped>
body {
  overflow: hidden;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue